import { Button } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";

type PersonContactInfoModalFooterProps = {
  isSaving: boolean;
  onCancel: () => void;
  onSave: () => void;
};

export const PersonContactInfoModalFooter = ({
  isSaving,
  onCancel,
  onSave,
}: PersonContactInfoModalFooterProps) => {
  const { t } = useTranslation("people", {
    keyPrefix: "PERSON_CONTACT_INFO_MODAL.FOOTER",
  });

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      py="300"
      px="500"
      borderTop="1px solid"
      borderTopColor="border.light"
      boxShadow="0 0 8px 0 rgba(0, 0, 0, 0.10);"
    >
      <Button mode="light" type="button" onClick={onCancel}>
        {t("CANCEL")}
      </Button>
      <Button
        visual="accent.blue"
        type="button"
        isLoading={isSaving}
        onClick={onSave}
      >
        {t("SAVE")}
      </Button>
    </Flex>
  );
};
